import { Box, Label, Tag } from '@nimbus-ds/components';
import { InterfaceNameValue, RadioButtonGroup } from '@tiendanube/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';
import { useOrdersSubscriptionFilter } from './useOrdersSubscriptionFilter';
import './OrdersSubscriptionFilter.scss';

interface OrdersSubscriptionFilterProps {
  value?: string;
  onChange: ({ name, value }) => void;
}

export function OrdersSubscriptionFilter({
  value,
  onChange,
}: Readonly<OrdersSubscriptionFilterProps>) {
  const t = useTranslationOrders('filters.isSubscriptionFilter');
  const { filterOptions } = useOrdersSubscriptionFilter();

  const handleRadioChange = (e: InterfaceNameValue) => {
    onChange({ name: 'isSubscription', value: e.value });
  };

  return (
    <Box borderStyle="none">
      <Box paddingBottom="2" display="flex" alignItems="center" gap="1">
        <Label>{t('label')}</Label>
        <Tag appearance="primary">{t('tag')}</Tag>
      </Box>
      <Box>
        <div className="stratus--orders-subscription-filter-radio-group">
          <RadioButtonGroup
            name="isSubscription"
            options={filterOptions}
            onChange={handleRadioChange}
            value={value ?? ''}
          />
        </div>
      </Box>
    </Box>
  );
}
